export default "__VITE_ASSET__C9r6TF6s__"